'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = entities;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _aman = require('../actions/aman');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getAmanSuscribedBranches),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(suscribeBranchesToAman),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(editAmanBranchSubscribtion),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(entities);

function getAmanSuscribedBranches(payload /*: { branchesKeys: Array<string> }*/) {
  var branchesKeys, parameters, amanBranches, getbranches;
  return _regenerator2.default.wrap(function getAmanSuscribedBranches$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          branchesKeys = payload.branchesKeys;
          parameters = [];

          branchesKeys.map(function (branchKey) {
            parameters.push(encodeURI('branchKeys=' + branchKey));
            return true;
          });

          amanBranches = new _webUtils.API();
          _context.next = 6;
          return amanBranches.get(_webUtils.Urls.aman.providers + '?' + parameters.join('&'));

        case 6:
          getbranches = _context.sent;

          if (!_webUtils.STATUS.isSuccess(getbranches.status)) {
            _context.next = 12;
            break;
          }

          _context.next = 10;
          return (0, _effects.put)({
            type: _aman.AMAN.FETCH.SUCCEEDED,
            amanBranches: getbranches.data.Branches
          });

        case 10:
          _context.next = 14;
          break;

        case 12:
          _context.next = 14;
          return (0, _effects.put)({
            type: _aman.AMAN.FETCH.FAILED
          });

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function suscribeBranchesToAman(payload /*: { branchesKeys: Array<string> }*/) {
  var branchesKeys, branches, amanSignUp, signUp;
  return _regenerator2.default.wrap(function suscribeBranchesToAman$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          branchesKeys = payload.branchesKeys;
          branches = branchesKeys.map(function (branchKey) {
            return {
              branchKey: branchKey
            };
          });
          amanSignUp = new _webUtils.API();
          _context2.next = 5;
          return amanSignUp.post(_webUtils.Urls.aman.signUp, {
            branches: branches
          });

        case 5:
          signUp = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(signUp.status)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)({
            type: _aman.AMAN.SUBSCIBE.SUCCEEDED
          });

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)({
            type: _aman.AMAN.SUBSCIBE.FAILED,
            err: signUp.data
          });

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function editAmanBranchSubscribtion(payload /*: { branchDetails: Object }*/) {
  var branchDetails, apiBody, amanSignUp, signUp;
  return _regenerator2.default.wrap(function editAmanBranchSubscribtion$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          branchDetails = payload.branchDetails;
          apiBody = {
            branches: [{
              branchKey: branchDetails
            }]
          };
          amanSignUp = new _webUtils.API();
          _context3.next = 5;
          return amanSignUp.post(_webUtils.Urls.aman.signUp, apiBody);

        case 5:
          signUp = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(signUp.status)) {
            _context3.next = 11;
            break;
          }

          _context3.next = 9;
          return (0, _effects.put)({
            type: _aman.AMAN.EDIT.SUCCEEDED
          });

        case 9:
          _context3.next = 13;
          break;

        case 11:
          _context3.next = 13;
          return (0, _effects.put)({
            type: _aman.AMAN.EDIT.FAILED
          });

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function entities() {
  return _regenerator2.default.wrap(function entities$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_aman.AMAN.SUBSCIBE.LOADING, suscribeBranchesToAman);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeEvery)(_aman.AMAN.FETCH.LOADING, getAmanSuscribedBranches);

        case 4:
          _context4.next = 6;
          return (0, _effects.takeEvery)(_aman.AMAN.EDIT.LOADING, editAmanBranchSubscribtion);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}
module.exports = exports['default'];